<script>
import render from '@/render/render'
import { copy } from '@/utils'
export default {
    name: 'Collapse',
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        accordion: {
            type: Boolean,
            default: false
        },
        tabs: {
            type: Array,
            default: () => [],
        }
    },
    watch: {
        value: {
            handler(value) {
                if(Array.isArray(value)) {
                   this.info = copy(value)
                }
            },
            deep: true,
            immediate: true,
        },
        propTabs: {
            handler(value) {
                const { eventHub, __vModel__ } = this.$attrs
                eventHub.emit('designProps', { property: 'tabs', data: value, key: __vModel__} )
            },
            deep: true
        }
    },
    created() {
        const { componentToRegister, design } = this.$attrs
        if(design) {
            this.design = true
        }
        if(Array.isArray(componentToRegister)) {
            const [DraggableItem, draggable] = componentToRegister
            console.log(componentToRegister, componentToRegister.name)
            this.$options.components['draggable-item'] = DraggableItem
            this.$options.components['draggable'] = draggable
        }
    },
    data() {
        return {
            info: [],
            design: false,
            propTabs: copy(this.tabs)
        }
    },
    render() {
        const { accordion, tabs, propTabs } = this
        const { formSlot: { scopedSlots } } = this.$attrs
        const setValue = (label, key, value) => {
            console.log(label, key, value)
            const data = this.info
            const item = data.find(item => item.label === label)
            if(item) {
                if(item.data) {
                    item.data[key] = value
                }
            } else {
                data.push({
                    label: label,
                    data: {
                        [key]: value
                    }
                })
            }
            this.$emit('input', data)
        }
        const { design } = this.$attrs
        return (
            <el-collapse accordion={accordion}>
                {
                    propTabs.map(tab => (
                        <el-collapse-item title={tab.label} name={tab.label}>
                            {
                                design ? (
                                    <div>
                                        <draggable list={tab.rows} animation={340} group="componentsGroup">
                                            {
                                                tab.rows.map((item, index) => {
                                                    return (
                                                        <draggable-item 
                                                            key={index}
                                                            current-item={item}
                                                            drawing-list={tab.rows}
                                                            index={index}
                                                            in-table={true}
                                                            onActiveItem={item => {
                                                                const { eventHub } = this.$attrs
                                                                eventHub.emit('activeItem', item )
                                                            }}
                                                            onDeleteItem={index => tab.rows.splice(index, 1)}
                                                        />
                                                    )
                                                })
                                            }
                                        </draggable>
                                        <div style="color: #c0bebe; text-align: center; width: 90%; padding: 5px">
                                            ☝ 拖拽控件到表格内部
                                        </div>
                                    </div>
                                ) :
                                tab.rows.map( item => {
                                    const { __vModel__, __config__ } = item
                                    const { span, showLabel, label } = __config__
                                    let info
                                    const tabItem = this.info.find(item => item.label === tab.label)
                                    if(tabItem) {
                                        info = tabItem.data
                                    } else {
                                        info = {}
                                    }
                                    return (
                                        <el-col span={span} style="padding: 5px 0">
                                            <el-form-item label-width="120px" prop={__vModel__} label={showLabel ? label : ""}>
                                                <render info={info} formSlot={{scopedSlots}} conf={item} onInput={value => setValue(tab.label, __vModel__, value)} attrs={this.$attrs} />
                                            </el-form-item>
                                        </el-col>
                                    )
                                })
                            }
                        </el-collapse-item>
                    ))
                }
            </el-collapse>
        )
    }
}
</script>